import { render, staticRenderFns } from "./UploadBoxIcon.vue?vue&type=template&id=defeff24"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('defeff24')) {
      api.createRecord('defeff24', component.options)
    } else {
      api.reload('defeff24', component.options)
    }
    module.hot.accept("./UploadBoxIcon.vue?vue&type=template&id=defeff24", function () {
      api.rerender('defeff24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/UploadBoxIcon.vue"
export default component.exports